export const PAGE_HEIGHT = 1400;
export const PAGE_HEIGHT_PDF = 1250;
export const PAGE_WIDTH = 950;
export const PAGE_WIDTH_PDF = 900;
export const HEIGHT_TOLERANCE_PX = 0.5;
